import React from "react"

import Layout from '@components/layout'
import Home from '@components/home'

export default () => {
  return(
    <Layout>
      <Home />
    </Layout>
  )
}
